import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { A11yOnly as A11yOnlyBase } from '@lmig/lmds-react-a11y';
import classnames from 'classnames';
import PropTypes from 'prop-types';

/* eslint-disable max-len */
/**
 * @see [LMDS A11yOnly Documentation and Examples](https://designsystem.lmig.com/components/a11y/code)
 *
 * API:
 *
 * @implements [A11yOnlyProps](https://designsystem.lmig.com/components/a11y/code#a11yonly-props)
 * @extends [HTMLSpanElement](https://microsoft.github.io/PowerBI-JavaScript/interfaces/_node_modules_typedoc_node_modules_typescript_lib_lib_dom_d_.htmlspanelement.html)
 */
/* eslint-enable max-len */

var A11yOnly = function A11yOnly(props) {
  var className = props.className;
  return /*#__PURE__*/React.createElement(A11yOnlyBase, _extends({}, props, {
    className: classnames('lm-a11yOnly', className)
  }));
};
A11yOnly.propTypes = {
  className: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.string, PropTypes.node]).isRequired
};
A11yOnly.defaultProps = {
  className: undefined
};
export default A11yOnly;